/* 料金区分 */
export default {
    // A料金
    PRICE_A: "10",
    // B料金
    PRICE_B: "20"
}